import { TransformRule } from "../transformation/TransformRule";
import { BaseFieldConfig, BaseFieldConfigData } from "./BaseFieldConfig";
import { HeliosColumnConfig } from "./helios/ColumnConfig";

export { ColumnConfig, ColumnConfigData };

type ColumnConfigData = BaseFieldConfigData & {
  helios?: HeliosColumnConfig;
  rowMandatory?: boolean;
};

class ColumnConfig extends BaseFieldConfig {
  helios?: HeliosColumnConfig | undefined;
  rowMandatory: boolean;

  constructor(data: ColumnConfigData) {
    super(data);
    this.helios = data.helios;
    this.rowMandatory = data.rowMandatory ?? false;
  }

  setTransformRules(rules: TransformRule[]) {
    this.transformationRules = rules;
  }

  static createTest(rest: Partial<ColumnConfigData> = {}): ColumnConfig {
    const data: ColumnConfigData = {
      fieldName: "",
      description: "",
      displayTab: "",
      threshold: 0,
      ocrConfidenceThreshold: this.DEFAULT_OCR_THRESHOLD,
      hidden: false,
      generateReuse: false,
      applyReuse: false,
      multiline: false,
      rowMandatory: false,
      position: 0,
      validator: {
        clientValidationOperator: "OR",
        validationRules: [],
        fieldName: "",
      },
      transformationRules: [],
    };

    return new ColumnConfig({
      ...data,
      ...rest,
    });
  }

  public toData(): ColumnConfigData {
    return {
      helios: this.helios ? { ...this.helios } : undefined,
      generateReuse: this.generateReuse,
      applyReuse: this.applyReuse,
      multiline: this.multiline,
      rowMandatory: this.rowMandatory,
      fieldName: this.fieldName,
      description: this.description,
      position: this.position,
      displayTab: this.displayTab,
      ocrConfidenceThreshold: this.ocrConfidenceThreshold,
      threshold: this.threshold,
      hidden: this.hidden,
      validator: this.validator,
      transformationRules: this.transformationRules.map((x) => x.toData()),
    };
  }
}
